<template>
  <nav>
    <h1 v-resize-text="{ ratio: 0.55 }">
      <a href="/">Blue Temple</a>
    </h1>
    <a href="#" class="menu-icon" @click="toggleNav"></a>

    <div class="header-wrapper-content" ref="nav">
      <!-- Menu Items -->
      <div class="menu-items" role="tablist">
        <!-- menu item: chronology -->
        <b-card no-body class="menu-item-chronology">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle="'accordion-1'"
              variant="info"
              v-on:click="sortBy('chronology')"
              >chronology</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="submenu-items">
                <button
                  v-for="(submenu, indexC) in submenusChronology"
                  v-bind:class="{ active: activeSubmenu === indexC }"
                  v-on:click="
                    sortBy('chronology', submenu);
                    setActive(indexC);
                  "
                  :key="indexC"
                >
                  {{ submenu }}
                </button>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- menu item: scale -->
        <b-card no-body class="menu-item-scale">
          <b-card-header header-tag="header" class="p-2" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle="'accordion-2'"
              variant="info"
              v-on:click="sortBy('scale')"
              >scale</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="submenu-items">
                <button
                  v-for="(submenu, index) in submenusScale"
                  v-bind:class="{ active: activeSubmenu === index }"
                  v-on:click="
                    sortBy('scale', submenu);
                    setActive(index);
                  "
                  :key="index"
                >
                  {{ submenu }}
                </button>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- menu item: program -->
        <b-card no-body class="menu-item-program">
          <b-card-header header-tag="header" class="p-3" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle="'accordion-3'"
              variant="info"
              v-on:click="sortBy('program')"
              >program</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="submenu-items">
                <button
                  v-for="(submenu, index) in submenusProgram"
                  v-bind:class="{ active: activeSubmenu === index }"
                  v-on:click="
                    sortBy('program', submenu);
                    setActive(index);
                  "
                  :key="index"
                >
                  {{ submenu }}
                </button>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- menu item: region -->
        <b-card no-body class="menu-item-region">
          <b-card-header header-tag="header" class="p-4" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle="'accordion-4'"
              variant="info"
              v-on:click="sortBy('region')"
              >region</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="submenu-items">
                <button
                  v-for="(submenu, index) in submenusRegion"
                  v-bind:class="{ active: activeSubmenu === index }"
                  v-on:click="
                    sortBy('region', submenu);
                    setActive(index);
                  "
                  :key="index"
                >
                  {{ submenu }}
                </button>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- menu item: name -->
        <b-card no-body class="menu-item-name">
          <b-card-header header-tag="header" class="p-5" role="tab">
            <b-button
              block
              href="#"
              v-on:click="sortBy('name', 'name')"
              v-b-toggle="'accordion-5'"
              variant="info"
              >name</b-button
            >
          </b-card-header>
        </b-card>

        <!-- menu items: old-->
        <!-- <b-card
          no-body
          class=""
          v-for="(filter, index) in filters"
          :key="index"
        >
          <b-card-header header-tag="header" :class="'p-' + index" role="tab">
            <b-button
              block
              href="#"
              v-b-toggle="'accordion-' + index"
              variant="info"
              >{{ filter }}</b-button
            >
          </b-card-header>
          <b-collapse
            :id="'accordion-' + index"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <ul class="submenu-items">
                <button
                  v-for="(submenu, index) in submenus"
                  v-bind:class="{ active: activeSubmenu === index }"
                  v-on:click="
                    sortBy(filter, submenu);
                    setActive(index);
                  "
                  :key="index"
                >
                  {{ submenu }}
                </button>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-n">
          <b-card-header header-tag="header" class="p-n" role="tab">
            <b-button block href="#" v-b-toggle.accordion-n variant="info"
              >-</b-button
            >
          </b-card-header>
        </b-card> -->
      </div>

      <!-- Filters -->
      <ul class="menu-filter">
        <li class="menu-filter-item">
          <!-- switch to grid -->
          <a
            href="#"
            class="menu-filter-item--columns"
            @click="
              viewGrid();
              toggleNav();
            "
          >
            <span class="layer layer--primary">
              <span></span>
            </span>
            <span class="layer layer--secondary">
              <span></span>
            </span>
            <span class="layer layer--tertiary">
              <span></span>
            </span>
          </a>
        </li>
        <li class="menu-filter-item">
          <!-- switch to list -->
          <a
            href="#"
            class="menu-filter-item--rows"
            @click="
              viewList();
              toggleNav();
            "
          >
            <span class="rows-icon"></span>
            <span class="rows-icon"></span>
            <span class="rows-icon"></span>
          </a>
        </li>
      </ul>

      <div class="footer">
        <!-- Social Icons -->
        <ul class="menu-social">
          <li class="menu-social-item">
            <a
              :href="'mailto:' + navLinks.email"
              class="menu-social-item--email"
              ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M464 64H48a48 48 0 00-48 48v288a48 48 0 0048 48h416a48 48 0 0048-48V112a48 48 0 00-48-48zm0 32c2.2 0 4.2.5 6.1 1.2L256 282.8 41.9 97.2c1.9-.8 4-1.2 6.1-1.2h416zm0 320H48a16 16 0 01-16-16V131l213.5 185a16.1 16.1 0 0021 0L480 131v269a16 16 0 01-16 16z"
                /></svg
            ></a>
          </li>
          <li class="menu-social-item">
            <a
              :href="navLinks.ig"
              target="_blank"
              class="menu-social-item--instagram"
              ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511 511">
                <path
                  d="M510.5 150.2a186.4 186.4 0 00-11.9-62 125.6 125.6 0 00-29.5-45.3 124.9 124.9 0 00-45.2-29.4 187 187 0 00-62-11.9C334.5.3 325.8 0 256.4 0s-78.1.3-105.3 1.5a186.4 186.4 0 00-62 11.9 125.1 125.1 0 00-45.3 29.5 124.9 124.9 0 00-29.4 45.2 187 187 0 00-11.9 62C1.2 177.5.9 186.1.9 255.5s.3 78.1 1.5 105.3c1.2 27.2 5.6 45.8 11.9 62a127 127 0 0029.5 45.3c12.8 13 28.3 23.1 45.2 29.4a187 187 0 0062 11.9c27.2 1.2 35.9 1.5 105.3 1.5s78.1-.3 105.3-1.5c27.2-1.2 45.8-5.6 62-11.9a130.9 130.9 0 0074.8-74.8 187 187 0 0011.9-62c1.2-27.3 1.5-35.9 1.5-105.3s-.1-77.9-1.3-105.2zm-46 208.7c-1.1 25-5.3 38.4-8.8 47.4a84.9 84.9 0 01-48.5 48.5c-9 3.5-22.6 7.7-47.4 8.8-27 1.2-35 1.5-103.2 1.5s-76.4-.3-103.2-1.5c-25-1.1-38.4-5.3-47.4-8.8a77.6 77.6 0 01-29.3-19.1 80 80 0 01-19.1-29.3c-3.5-9-7.7-22.6-8.8-47.4-1.2-27-1.5-35-1.5-103.2s.3-76.4 1.5-103.2c1.1-25 5.3-38.4 8.8-47.4a75.6 75.6 0 0119.1-29.4A80 80 0 01106 56.7c9-3.5 22.6-7.7 47.4-8.8 27-1.2 35-1.5 103.2-1.5 68.3 0 76.4.3 103.2 1.5 25 1.1 38.4 5.3 47.4 8.8a77.6 77.6 0 0129.3 19.1c8.5 8.3 15 18.3 19.1 29.4 3.5 9 7.7 22.6 8.8 47.4 1.2 27 1.5 35 1.5 103.2s-.2 76.1-1.4 103.1z"
                />
                <path
                  d="M256.4 124.3a131.3 131.3 0 100 262.6 131.3 131.3 0 000-262.6zm0 216.4a85.2 85.2 0 110-170.4 85.2 85.2 0 010 170.4zM423.6 119.1a30.6 30.6 0 11-61.2 0 30.6 30.6 0 0161.2 0z"
                /></svg
            ></a>
          </li>
          <li class="menu-social-item">
            <a
              :href="navLinks.fb"
              target="_blank"
              class="menu-social-item--facebook"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 682.7 682.7"
              >
                <path
                  d="M625.7 21H56.3A35.3 35.3 0 0021 56.3v569.4A35.3 35.3 0 0056.3 661h306.5V413.5h-83.1v-96.9h83.1v-71.3c0-82.7 50.5-127.7 124.2-127.7 35.3 0 65.7 2.6 74.5 3.8v86.4h-50.9c-40.1 0-47.9 19.1-47.9 47.1v61.7h95.9l-12.5 96.9h-83.4V661h162.8a35.3 35.3 0 0035.3-35.3V56.3A35 35 0 00625.7 21z"
                /></svg
            ></a>
          </li>
          <li class="menu-social-item">
            <a
              :href="navLinks.li"
              target="_blank"
              class="menu-social-item--linkedin"
              ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 510">
                <path
                  d="M459 0H51C23 0 0 22.9 0 51v408c0 28 23 51 51 51h408c28 0 51-23 51-51V51c0-28.1-23-51-51-51zM153 433.5H76.5V204H153v229.5zm-38.2-272.9c-25.5 0-45.9-20.4-45.9-45.9s20.4-45.9 45.9-45.9 45.9 20.4 45.9 45.9-20.5 45.9-45.9 45.9zm318.7 272.9H357V298.4c0-20.4-17.9-38.2-38.2-38.2s-38.2 17.9-38.2 38.2v135.1H204V204h76.5v30.6a82.5 82.5 0 0163.8-35.7 90.3 90.3 0 0189.2 89.3v145.3z"
                /></svg
            ></a>
          </li>
        </ul>
        <router-link
          to="/getinvolved"
          class="get-involved-cta get-involved-cta--white"
          v-on:click.native="toggleNav()"
          >get involved</router-link
        >
      </div>
    </div>
  </nav>
</template>

<script>
import { bus } from "../main";
// import Accordion from "@/components/Accordion.vue";
import ResizeText from "vue-resize-text";
import axios from "axios";

export default {
  props: ["navLinks"],
  components: {},
  directives: {
    ResizeText
  },
  data() {
    return {
      filters: ["chronology", "scale", "program", "region", "name"],
      submenusChronology: [],
      submenusScale: [],
      submenusProgram: [],
      submenusRegion: [],
      submenusName: [],
      submenus: [
        "public spaces",
        "commercial",
        "master plan",
        "workshop",
        "mapping"
      ],
      active: false,
      activeSubmenu: undefined,
      text: "hello",
      socialLinks: [],
      socialE: "",
      socialIg: "",
      socialFb: "",
      socialLi: ""
    };
  },
  created() {
    bus.$on("toggleNav", () => {
      this.toggleNav();
    });
    this.socialE = this.$props.navLinks.email;
    this.socialIg = this.$props.navLinks.ig;
    this.socialFb = this.$props.navLinks.fb;
    this.socialLi = this.$props.navLinks.li;
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var self = this;
      axios
        .get(
          "https://api.blue-temple.com/projects?_with=status,location,type,tag"
        )
        .then(function(res) {
          console.log(res.data.data);
          var projects = res.data.data;
          var x;

          for (x = 0; x < projects.length; x++) {
            // Menu Item: Chronology
            var newYear = projects[x].year;
            // avoid duplicates
            if (!self.submenusChronology.includes(newYear)) {
              self.submenusChronology.push(newYear);
            }

            // Menu Item: Scale
            var newScale = projects[x].scale;
            // avoid duplicates
            if (!self.submenusScale.includes(newScale)) {
              self.submenusScale.push(newScale);
            }

            // Menu Item: Program
            var newProgram = projects[x].type.data.name;
            // avoid duplicates
            if (
              !self.submenusProgram.includes(newProgram) &&
              newProgram !== "Featured"
            ) {
              self.submenusProgram.push(newProgram);
            }

            // Menu Item: Region
            var newRegion = projects[x].location.data.name;
            // avoid duplicates
            if (!self.submenusRegion.includes(newRegion)) {
              self.submenusRegion.push(newRegion);
            }
          }
          // sort Menu Items
          self.submenusChronology = self.submenusChronology.reverse();
          self.submenusScale = self.submenusScale.sort();
          self.submenusRegion = self.submenusRegion.sort((a, b) =>
            a < b ? 1 : -1
          );
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    toggleNav() {
      // console.log("togglenav");
      const nav = this.$refs.nav.classList;
      const el = document.querySelector(".menu-icon");

      nav.contains("active") ? nav.remove("active") : nav.add("active");
      el.classList.contains("menu-icon--close")
        ? el.classList.remove("menu-icon--close")
        : el.classList.add("menu-icon--close");
    },
    viewGrid() {
      const list = document.querySelector(".projects");
      const listExtras = document.querySelector(".projects--list-extras");

      if (list.classList.contains("projects--list")) {
        list.classList.remove("projects--list");
        listExtras.classList.remove("projects--list-extras--visible");
        list.classList.add("projects--grid");
      }
    },
    viewList() {
      const list = document.querySelector(".projects");
      const listExtras = document.querySelector(".projects--list-extras");

      if (list.classList.contains("projects--grid")) {
        list.classList.remove("projects--grid");
        list.classList.add("projects--list");
        listExtras.classList.add("projects--list-extras--visible");
      }
    },
    setActive(index) {
      this.activeSubmenu = index;
    },
    sortBy(prop, tag) {
      console.log(prop, tag);
      // if (
      //   (this.$route.name && this.$route.name !== "Home") ||
      //   document.querySelector("body").classList.contains("class-project")
      // ) {
      //   this.$router.push({ name: "Home" });
      // }
      //
      // reset active submenu
      this.activeSubmenu = "";
      bus.$emit("sorted", { prop: prop, tag: tag });
      this.toggleNav();
    }
  }
};
</script>

<style scoped lang="scss">
nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  height: 60px;
  margin: 0 auto;
  z-index: 90;

  .menu-icon {
    position: relative;
    display: none;
    width: 19px;
    height: 6px;

    &::before,
    &::after {
      position: absolute;
      bottom: 0;
      width: 2px;
      height: 15px;
      background: $color-light;
      transition: all 0.3s ease;
      content: "";
    }

    &::before {
      transform: rotate(-45deg) translate3d(-7px, 0, 0);
    }

    &::after {
      transform: rotate(45deg) translate3d(7px, 0, 0);
    }

    &--close {
      &::before {
        transform: rotate(-45deg) translate3d(0, 0, 0);
      }

      &::after {
        transform: rotate(45deg) translate3d(0, 0, 0);
      }
    }
  }

  button {
    display: block;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    font-family: "rajdhaniregular";
    font-size: 26px;
    font-weight: normal;
    color: $color-lightgrey-title;
    text-align: left;
    background: none;
    border: 0;
    outline: none;

    &:hover {
      cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
    }
  }

  /*  */
  .menu-items {
    display: flex;
    flex-direction: column;
    height: auto;
    align-items: center;
    margin-top: 40px;

    .card,
    li {
      display: block;
      width: 100%;
      padding-left: 0;
      padding-right: 0;
      font-family: "rajdhaniregular";
      font-size: 26px;
      font-weight: normal;
      color: $color-lightgrey;
      outline: none;
    }

    > a {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      color: inherit;
      text-decoration: none;
    }

    li {
      list-style-type: none;
    }
  }

  /* */
  .submenu-items {
    margin: 5px 0;
    padding-left: 18px;

    button {
      font-size: 16px;
      line-height: 26px;
      text-transform: lowercase;

      &:hover,
      &.active {
        font-family: "rajdhanimedium";
        text-transform: uppercase;
        color: $color-light;
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
      }
    }
  }

  /* */
  .menu-filter {
    display: block;
    margin-bottom: 10vh;
  }

  .menu-filter-item {
    position: relative;
    display: block;
    width: 24px;
    height: 24px;
    text-align: center;
    margin: 12px auto 0;

    &--rows {
      position: relative;
      display: block;
      width: 24px;
      height: 21px;
      margin: 16px auto 0;

      &:hover {
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;

        .rows-icon {
          background-color: $color-light;
        }
      }

      .rows-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 3px;
        background-color: $color-lightgrey;
      }

      .rows-icon + .rows-icon {
        top: 9px;
      }

      .rows-icon + .rows-icon + .rows-icon {
        top: 18px;
      }
    }

    &--columns {
      position: relative;
      display: block;
      width: 24px;
      height: 24px;
      margin: 0 auto;

      &:hover {
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;

        .layer > span,
        .layer > span:before,
        .layer > span:after {
          background-color: $color-light;
        }
      }
    }

    .layer {
      position: absolute;
      display: block;
      width: 100%;
      height: 5px;
    }

    .layer--primary {
      display: block;
      top: 0;
    }

    .layer--secondary {
      display: block;
      top: 50%;
      margin-top: -3px;
    }

    .layer--tertiary {
      display: block;
      bottom: 1px;
    }

    .layer > span {
      position: absolute;
      display: block;
      width: 5px;
      height: 5px;
      left: 50%;
      margin-left: -3px;
      background-color: $color-lightgrey;
    }

    .layer > span:before,
    .layer > span:after {
      display: block;
      content: "";
      width: 5px;
      height: 5px;
      background-color: $color-lightgrey;
      position: absolute;
    }

    .layer > span:before {
      left: -10px;
    }

    .layer > span:after {
      right: -10px;
    }
  }
}

/* mobile */
@media screen and (max-width: 759px) {
  nav {
    position: relative;
    padding: 0 20px;

    .card a:not(.collapsed) {
      text-transform: uppercase;
      color: $color-light;
    }

    /* */
    button {
      font-size: 26px;
      text-align: center;
    }

    .menu-icon {
      display: block;
    }

    .header-wrapper-content {
      position: absolute;
      top: 60px;
      left: 0;
      width: 100%;
      height: calc(100vh - 60px);
      flex-direction: column;
      justify-items: center;
      align-items: center;
      text-align: center;
      transform: translate3d(100vw, 0, 0);
      transition: all 300ms ease;
      background: $color-darkgrey;

      &.active {
        transform: translate3d(0, 0, 0);
      }
    }

    .menu-items {
      display: flex;
      flex-direction: column;

      .card,
      li {
        display: block;
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        // font-family: 'rajdhaniregular';
        font-size: 26px;
        font-weight: normal;
        color: $color-lightgrey;
      }

      a {
        color: inherit;
        text-decoration: none;
      }
    }

    .menu-filter {
      margin-bottom: 0;
    }

    .submenu-items {
      padding: 0;
    }

    .footer {
      position: relative;
      top: auto;
      right: auto;
      bottom: auto;
      left: auto;
      margin-top: 50px;

      .menu-social {
        margin: 0 auto;
      }
    }
  }
}

/* desktop */
@media screen and (min-width: 1024px) {
  nav {
    position: fixed;
    padding: 3.1vw !important;
    overflow: hidden;
    border: 2px solid transparent;

    h1 {
      font-size: 3.5vw;
    }

    .menu-items {
      .card,
      li {
        margin-bottom: 5px;

        a:hover {
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          color: $color-light;
          text-transform: uppercase;
        }
      }
    }
  }
}

/* tablet + desktop */
@media screen and (min-width: 768px) {
  nav {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 25vw;
    height: 100%;
    padding: 22px;

    &:after {
      position: absolute;
      top: 0;
      right: 0;
      content: "";
      width: 2px;
      height: 100vh;
      background-image: linear-gradient(
        to bottom,
        #969696 55%,
        rgba(255, 255, 255, 0) 20%
      );
      background-position: top;
      background-size: 2px 30px;
      background-repeat: repeat-y;
    }

    .menu-items {
      display: flex;
      flex-direction: column;
      height: auto;

      .card,
      li {
        margin-bottom: 0;
        font-family: "rajdhaniregular";
        font-size: 26px;
      }

      a {
        color: inherit;
        text-decoration: none;
      }
    }

    .submenu-items {
      button {
        font-size: 12px;
        line-height: 22px;
      }
    }

    .menu-filter {
      text-align: left;
    }

    .menu-filter-item {
      margin: 12px 0 0;
    }
  }
}

/* desktop */
@media screen and (min-width: 1024px) {
  nav {
    .submenu-items {
      button {
        font-size: 18px;
        line-height: 24px;
      }
    }
  }
}
</style>
